<form [formGroup]="form" (ngSubmit)="submit()">
<!-- FORM HEAD-->
  <div class="pt-4 pb-3 d-flex justify-content-between form-header">
    <div class="w-100">
      @if(!isUpdate){
        <h3 class="fs-5">{{ 'create_teammember' | translate }}</h3>
      }@else{
        <div class="d-flex align-items-center justify-content-between pb-2">
          <div class="d-flex align-items-center">
            <h3 class="fs-5 mb-0 me-3">{{member.firstname}} {{member.lastname}}</h3>
            <div class="form-group">
              <mat-select formControlName="active" panelClass=""
                          [matTooltip]="'cannot_update_own_activation' | translate"
                          matTooltipPosition="above"
                          [matTooltipDisabled]="memberId !== currentUser?.id"
                          (selectionChange)="toggle_status($event)">
                <mat-select-trigger class="activeBtn" >
                  @if(active.value){
                    <span class="badge badge-active">
                      <i class="fa-solid fa-circle pe-2"></i>{{'account_activated' | translate}}<i class="fa-solid fa-chevron-down ps-2"></i>
                    </span>
                  }@else{
                    <span class="badge badge-disabled">
                      <i class="fa-solid fa-circle pe-2"></i>{{'account_disabled' | translate}}<i class="fa-solid fa-chevron-down ps-2"></i>
                    </span> 
                  }
                </mat-select-trigger>
                <mat-option [value]="true">{{'activate_account' | translate}}</mat-option>
                <mat-option [value]="false">{{'disable_account' | translate}}</mat-option>
              </mat-select>
            </div>
          </div>
          @if(member.bounced){
            <span matTooltip="{{member.bounced.date | slice:0:19}} - {{member.bounced.details}}">
                <p class="badge bg-danger">{{ 'email_delivery_failure' | translate }}</p>
            </span>
          }
        </div>
        <small class="d-block text-secondary">{{member.email}}</small>
      }
    </div>
  </div>
<mat-tab-group>
<!-- GENERAL INFOS -->
    <mat-tab>
      <ng-template mat-tab-label><i class="fa-solid fa-id-card"></i>&nbsp;{{'teamMember.info' | translate}}</ng-template>
      <div class="form-group pt-2 my-3">
        <label for="email" class="col-form-label">Email</label>
        <input type="email" class="form-control" id="email" name="email"
          formControlName="email"
          [matTooltip]="'cannot_update_email_belonging_to_many_teams' | translate"
          matTooltipPosition="above"
          [matTooltipDisabled]="$safeNavigationMigration(member?.teams?.length) <= 1"
          (blur)="fillFirstAndLastnameFromEmail()">
        @if (email.invalid && (email.dirty || email.touched)) {
          @if (email.errors?.['required']) {
            <div class="text-danger"
              >{{'error.required' |
            translate}}</div>
          }
          @if (email.errors?.['email']) {
            <div class="text-danger">{{'error.email' |
            translate}}</div>
          }
        }
      </div>
      <div class="form-group row mb-3">
        <div class="col-md-6">
          <label for="firstname" class="col-form-label">{{'firstname' |
          translate}}</label>
          <input type="text" class="form-control firstname-autosave"
            id="firstname" name="firstname" formControlName="firstname">
          @if (firstname.invalid && (firstname.dirty || firstname.touched)) {
            @if (firstname.errors?.['required']) {
              <div class="text-danger"
                >{{'error.required' |
              translate}}</div>
            }
          }
        </div>
        <div class="col-md-6">
          <label for="lastname" class="col-form-label">{{'lastname' |
          translate}}</label>
          <input type="text" class="form-control lastname-autosave" id="lastname"
            name="lastname" formControlName="lastname">
          @if (lastname.invalid && (lastname.dirty || lastname.touched)) {
            @if (lastname.errors?.['required']) {
              <div class="text-danger"
                >{{'error.required' |
              translate}}</div>
            }
          }
        </div>
      </div>
      @if (team?.allowTags) {
        <div class="form-group mb-3">
            <label for="tags" class="col-form-label d-block">{{'tags' |
            translate}}</label>
            <tm-tags-input formControlName="tags" [allTags]="allTags"
                          (tagAdded)="add_tag($event)"
                          (tagRemoved)="remove_tag($event)">
            </tm-tags-input>
        </div>
      }
    </mat-tab>
<!-- ROLES -->
    <mat-tab>
      <ng-template mat-tab-label><i class="fa-solid fa-user-lock"></i>&nbsp;{{'teamMember.role' | translate}}</ng-template>
      <div class="form-group row pt-2 my-3">
        <team-member-roles
                [userRoles]="member.roles"
                           [teamId]="teamId"
                           [isCurrentUser]="currentUser?.id === member.id"
                           (onRoleChanges)="updateRole($event)"></team-member-roles>
      </div>
    </mat-tab>
<!-- NOTIFICATIONS -->
    <mat-tab [disabled]="disableNotificationTab">
        <ng-template mat-tab-label><i class="fa-solid fa-bell"></i>&nbsp;{{'teamMember.notification' | translate}}</ng-template>
      <h5 class="pt-2 mt-3 mb-0">{{ 'schedulingOptions' | translate }}</h5>
      <div class="form-group row mb-2" formGroupName="notificationTime">
        <div class="col-md-6">
          <label class="col-form-label" for="timeZone">{{'timeZone' |
          translate}}</label>
          <tm-timezone-picker formControlName="timeZone"></tm-timezone-picker>
        </div>
        <div class="col-md-6">
          <label class="col-form-label d-block">
          {{ 'preferedTimeForEmails' | translate}}</label>
          <tm-timepicker formControlName="time"></tm-timepicker>
        </div>
      </div>

      <div class="form-group row mb-2">
        <div class="col-md-12">
          <label class="col-form-label" for="workingDays">{{'workingDays' |
          translate}}</label><br>
          <tm-working-days id="workingDays"
          formControlName="workingDays"></tm-working-days>
        </div>
      </div>

      <div class="form-group row mb-2">
        <div class="col-md-12">
          <label class="col-form-label d-block" for="language">{{'language' |
          translate}}</label>
          <tm-language-select formControlName="language"></tm-language-select>
        </div>
      </div>

      @if (isUpdate) {
        <div class="form-group row">
          <div class="col-md-12">
            <label class="col-form-label m-0 d-block"
            for="outOfOffice">{{'outOfOffice' | translate}}</label>
            <tm-out-of-office formControlName="outOfOffice"></tm-out-of-office>
          </div>
        </div>
      }

      @if (isUpdate) {
        <hr>
        <h5 class="pt-1">{{ 'notification_channels' | translate
        }}</h5>
        <div class="form-group row mb-2">
          <div class="col-md-4">
            <label class="col-form-label">Email</label>
            <br>
              <tm-slide-toggle formControlName="emailEnabled"
                (ngModelChange)="toggle_channel('email-notification')">
              </tm-slide-toggle></div>
              <div class="col-md-4">
                <label class="col-form-label">Slack</label>
                <br>
                  <span [hidden]="!(member.slackEnabled !== null)">
                    <tm-slide-toggle formControlName="slackEnabled"
                      (ngModelChange)="toggle_channel('slack-notification')">
                    </tm-slide-toggle></span>
                    <span [hidden]="!(member.slackEnabled === null)">
                      <a
                        href="https://help.teammood.com/en/articles/973847-slack-integration"
                        target="_blank" class="btn btn-default">{{ 'not_configured' |
                        translate }} <i class="fa-regular fa-up-right-from-square"></i></a>
                      </span>
                    </div>
                    <div class="col-md-4">
                      <label class="col-form-label">MS Teams</label>
                      <br>
                        <span [hidden]="!(member.msTeamsEnabled !== null)">
                          <tm-slide-toggle formControlName="msTeamsEnabled"
                            (ngModelChange)="toggle_channel('msteams-notification')">
                          </tm-slide-toggle></span>
                          <span [hidden]="!(member.msTeamsEnabled === null)">
                            <a
                              href="https://help.teammood.com/en/articles/4294405-microsoft-teams-integration-for-teammood"
                              target="_blank" class="btn btn-default">{{ 'not_configured' |
                              translate }} <i class="fa-regular fa-up-right-from-square"></i></a>
                            </span>
                          </div>

        </div>
      }

      <!-- Hidden submit button to validate creation form when enter is pressed -->
      @if (!isUpdate) {
        <div hidden>
          <button type="submit" class="btn btn-primary"></button>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
</form>
